import { create } from "zustand";
import { api } from "@/lib/api";
import type { ReadMessageFeedbackWithContextDto } from "@package/types";
import type { AsyncState } from "./types";

interface FeedbackState extends AsyncState {
  feedbacks: ReadMessageFeedbackWithContextDto[];
}

interface FeedbackActions {
  loadFeedbacks: () => Promise<void>;
  deleteFeedback: (id: number) => Promise<void>;
  reset: () => void;
}

type FeedbackStore = FeedbackState & FeedbackActions;

export const useFeedbackStore = create<FeedbackStore>()((set) => ({
  feedbacks: [],
  isLoading: false,
  isLoaded: false,
  error: null,

  loadFeedbacks: async () => {
    set({ isLoading: true, error: null });
    try {
      const data =
        await api.get<ReadMessageFeedbackWithContextDto[]>("/feedback");
      set({ feedbacks: data, isLoading: false, isLoaded: true });
    } catch (error) {
      set({ isLoading: false, error: (error as Error).message });
    }
  },

  deleteFeedback: async (id: number) => {
    try {
      await api.delete(`/feedback/${id}`);
      set((state) => ({
        feedbacks: state.feedbacks.filter((f) => f.id !== id)
      }));
    } catch (error) {
      set({ error: (error as Error).message });
      throw error;
    }
  },

  reset: () =>
    set({ feedbacks: [], isLoading: false, isLoaded: false, error: null })
}));
